import { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface LeitorQRProps {
  ativo: boolean;
  aoLer: (codigo: string) => void;
  aoErroCamera: (mensagem: string) => void;
}

export default function LeitorQR({ ativo, aoLer, aoErroCamera }: LeitorQRProps) {
  const ativoRef = useRef(ativo);
  ativoRef.current = ativo;

  const aoLerRef = useRef(aoLer);
  aoLerRef.current = aoLer;

  const startPromiseRef = useRef<Promise<unknown> | null>(null);

  useEffect(() => {
    const scanner = new Html5Qrcode('portaria-qr');

    // Guarda a promise do start() para, ao desmontar, esperar ela assentar
    // antes de parar a câmera (evita deixar a câmera ligada no fundo).
    const startPromise = scanner.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 240, height: 240 } },
      (decodificado) => {
        if (!ativoRef.current) return;
        aoLerRef.current(decodificado);
      },
      () => {
        // frame sem QR legível — ignora, é normal
      },
    );
    startPromiseRef.current = startPromise;

    startPromise.catch((err) => {
      const msg =
        typeof err === 'string'
          ? err
          : (err as { message?: string })?.message || 'Câmera indisponível.';
      aoErroCamera(msg);
    });

    return () => {
      const p = startPromiseRef.current ?? Promise.resolve();
      p.finally(() => {
        scanner
          .stop()
          .then(() => scanner.clear())
          .catch(() => {
            /* câmera já liberada */
          });
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative h-full w-full overflow-hidden bg-black">
      <div id="portaria-qr" className="h-full w-full" />
      {/* cantos de mira */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[240px] w-[240px] -translate-x-1/2 -translate-y-1/2">
        <span className="absolute left-0 top-0 h-8 w-8 border-l-4 border-t-4 border-white/70" />
        <span className="absolute right-0 top-0 h-8 w-8 border-r-4 border-t-4 border-white/70" />
        <span className="absolute bottom-0 left-0 h-8 w-8 border-b-4 border-l-4 border-white/70" />
        <span className="absolute bottom-0 right-0 h-8 w-8 border-b-4 border-r-4 border-white/70" />
      </div>
    </div>
  );
}